module.exports = __webpack_public_path__ + "img/logo.d023e3ee.png";